import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=760ec81b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.3.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760ec81b"]])

export default __exports__